import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
import React from "react";
import { actionMotionStyles } from "../micro-interactions/actionMotion";
import { ButtonStyle } from "./style";
import { black500 } from "../../../constants/color";
export const OutlineButon = ({ children, motion = false, disabled, onClick, mt = 0, mb = 0, type = "button", }) => {
    return (_jsx(Box, { component: "button", disabled: disabled, onClick: onClick, width: "100%", mb: mb, type: type, sx: {
            ...ButtonStyle,
            ...(motion ? actionMotionStyles : {}),
            mt: `${mt}px`,
            // border:'1px solid #FFBC00'
            // background: disabled ? "#FFEAB2" : "#FFBC00",
            background: 'white',
            border: disabled ? "1px solid #FFBC00" : "1px solid #FFBC00",
            cursor: disabled ? "not-allowed" : "pointer",
        }, children: _jsx(Typography, { variant: "subtitle2", color: black500, children: children }) }));
};
